import { createStaticUrl } from '../utils';
import type { ThemePackageT } from '../types';
import Background from './Background';

const Export: ThemePackageT<{ index: number }> = {
  id: 'colorjoy',
  title: 'ColorJoy',
  background: Background,
  preview: {
    idle: createStaticUrl('static/themes/colorjoy/colorjoy_theme_idle.jpg'),
    hover: createStaticUrl('static/themes/colorjoy/colorjoy_theme_hover.gif'),
  },
};

export default Export;
